import React, { useContext, useMemo } from "react";
import { Bell } from "lucide-react";
import { NewContext } from "../utils/ContextProvider";
import "./NotificacionesCobertura.css";

const NotificacionesPendientes = ({ onOpenDashboard }) => {
  const { pendingSummary, getModules } = useContext(NewContext);

  const modules = useMemo(
    () => (typeof getModules === "function" ? getModules() : getModules) || [],
    [getModules]
  );

  const alertCount = useMemo(() => {
    if (!pendingSummary) return 0;
    let total = 0;
    total += pendingSummary.requests?.total ?? 0;
    total += pendingSummary.requestSignatures?.total ?? 0;
    if (modules.includes("SUELDOS")) {
      total += pendingSummary.receipts?.total ?? 0;
    }
    if (modules.includes("CAPACITACIONES")) {
      total += pendingSummary.courses?.total ?? 0;
    }
    if (modules.includes("HELPDESK")) {
      total += pendingSummary.tickets?.total ?? 0;
    }
    // TODO: reactivar cuando se implemente consentimiento legal
    // if (pendingSummary.legalConsent && !pendingSummary.legalConsent.accepted) {
    //   total += 1;
    // }
    return total;
  }, [pendingSummary, modules]);

  const handleClick = () => {
    if (onOpenDashboard) onOpenDashboard();
  };

  return (
    <div
      className="notificaciones-cobertura"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      aria-label={`Notificaciones${alertCount > 0 ? `, ${alertCount} pendientes` : ""}`}
      onKeyDown={(e) => e.key === "Enter" && handleClick()}
    >
      <div className="notif-bell-wrapper">
        <Bell
          size={18}
          className={`notif-bell-icon ${alertCount > 0 ? "has-alerts" : ""}`}
        />
        {alertCount > 0 && (
          <span className="notif-badge">
            {alertCount > 99 ? "99+" : alertCount}
          </span>
        )}
      </div>
    </div>
  );
};

NotificacionesPendientes.displayName = "NotificacionesPendientes";

export default NotificacionesPendientes;
